import { c as _c } from "react/compiler-runtime";
import './primary-cta-birthday.scss';
import { ButtonStyle } from '@sola/ark-core/atoms/button-style/button-style.tsx';
import { IntlBlock } from '@sola/ark-core/atoms/intl/Intl.tsx';
import { Link } from '@sola/ark-core/atoms/link/link.tsx';
import { Pictogram } from '@sola/ark-core/atoms/pictogram/pictogram.tsx';
import { cn } from '@sola/ark-core/utils/helpers.ts';
import { ArkIcon } from '@sola/ark-icons/lib/ark-icon.tsx';
import { getGivingChildGiftsPath } from '@sola/my-sdk/constants.ts';
import { GiftTypeEnum } from '@sola/schema/dotcom/cart/gift.ts';
import type { GraphQLCommitmentParticipant } from '@sola/schema/dotcom/supporters/schema.generated.ts';
import { PrimaryCta, PrimaryCtaActions, PrimaryCtaBody, PrimaryCtaHeading, PrimaryCtaIcon, PrimaryCtaText } from '../primary-cta/primary-cta.tsx';
import { usePrimaryCtaBirthday } from './primary-cta-birthday.logic.ts';
export type PrimaryCtaBirthdayProps = {
  participants: GraphQLCommitmentParticipant[];
  confirmed?: boolean;
};
const defaultParticipants: GraphQLCommitmentParticipant[] = [];
export const PrimaryCtaBirthday: React.FC<PrimaryCtaBirthdayProps> = t0 => {
  const $ = _c(32);
  const {
    participants: t1,
    confirmed: t2
  } = t0;
  const participants = t1 === undefined ? defaultParticipants : t1;
  const confirmed = t2 === undefined ? false : t2;
  let t3;
  if ($[0] !== confirmed || $[1] !== participants) {
    t3 = {
      participants,
      confirmed
    };
    $[0] = confirmed;
    $[1] = participants;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const {
    t,
    count,
    gender,
    title,
    subtitle
  } = usePrimaryCtaBirthday(t3);
  if (!participants || participants.length === 0) {
    return null;
  }
  const t4 = participants.length === 1 ? participants[0]?.globalId : undefined;
  let t5;
  if ($[3] !== t4) {
    t5 = getGivingChildGiftsPath(t4, GiftTypeEnum.Birthday);
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const birthdayGiftPath = t5;
  const t6 = confirmed ? "positive" : "default";
  let t7;
  if ($[5] !== confirmed) {
    t7 = cn("PrimaryCtaBirthday", {
      "PrimaryCtaBirthday--confirmed": confirmed
    });
    $[5] = confirmed;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  const t8 = confirmed ? "gift" : "birthday";
  let t9;
  if ($[7] !== t8) {
    t9 = <PrimaryCtaIcon><Pictogram name={t8} /></PrimaryCtaIcon>;
    $[7] = t8;
    $[8] = t9;
  } else {
    t9 = $[8];
  }
  let t10;
  if ($[9] !== title) {
    t10 = <PrimaryCtaHeading>{title}</PrimaryCtaHeading>;
    $[9] = title;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] !== subtitle) {
    t11 = <PrimaryCtaText>{subtitle}</PrimaryCtaText>;
    $[11] = subtitle;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  let t12;
  if ($[13] !== confirmed || $[14] !== count || $[15] !== gender || $[16] !== t) {
    t12 = confirmed && <p className="pt-snug-xl label-md md:label-lg label-moderate md:label-moderate label-neutral-mild"><IntlBlock i18nKey="my:primaryCtaBirthday.confirmation.cta" ns="my" count={count} context={gender} components={{
        letterLink: <Link href={t("my:primaryCtaBirthday.confirmation.url")} className="PrimaryCtaBirthday__link label-neutral-mild" />,
        cardLink: <Link href={t("my:primaryCtaBirthday.confirmation.url")} className="PrimaryCtaBirthday__link label-neutral-mild" />
      }} /></p>;
    $[13] = confirmed;
    $[14] = count;
    $[15] = gender;
    $[16] = t;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] !== t10 || $[19] !== t11 || $[20] !== t12) {
    t13 = <PrimaryCtaBody>{t10}{t11}{t12}</PrimaryCtaBody>;
    $[18] = t10;
    $[19] = t11;
    $[20] = t12;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] !== birthdayGiftPath || $[23] !== confirmed || $[24] !== t) {
    t14 = confirmed ? <PrimaryCtaActions><ArkIcon iconName="check-circle" className="PrimaryCtaBirthday__check-icon" /></PrimaryCtaActions> : <PrimaryCtaActions><ButtonStyle variant="secondary"><Link href={birthdayGiftPath}>{t("my:ctas.give.title")}</Link></ButtonStyle></PrimaryCtaActions>;
    $[22] = birthdayGiftPath;
    $[23] = confirmed;
    $[24] = t;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  let t15;
  if ($[26] !== t13 || $[27] !== t14 || $[28] !== t6 || $[29] !== t7 || $[30] !== t9) {
    t15 = <PrimaryCta variant={t6} className={t7}>{t9}{t13}{t14}</PrimaryCta>;
    $[26] = t13;
    $[27] = t14;
    $[28] = t6;
    $[29] = t7;
    $[30] = t9;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  return t15;
};